
export default function SidebarMenu() {
  window.scrollTo(0, 0)

  return (
    <></>
  )
}
